
// export default MyActionApprover;
import * as React from "react";
import { useState, useEffect, useContext, useCallback } from "react";
import {
  AppBar,
  Typography,
  Button,
  Box,
  Breadcrumbs,
  Link,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrn from "../../components/grid/ViewDataGridGrn";
import { ViewApproverGrnData, ViewMyApproverInitiator } from "../../components/grid/GridDataGrn";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ApprovalActionDialog from "../../components/grn/grnpopup/ApprovalActionDialog";
import SystemAlert from "../../components/common/SystemAlert";
import FilterGrnSearch from "../../components/grn/FilterGrnSearch";
import { useSelector } from "react-redux";
import { externalgetApi } from "../../services/externalApis";
import { GRN_API_02_2, GRN_API_17 } from "../../api/ApiModel";
import { FormatDate } from "../../utils/common/DateUtils";
import Switch from '@mui/material/Switch';
import { AnyForNow, GrnFilterState } from "./types";
import { SEARCH_FIELDS_MYACTIONS } from "../../utils/sys/GrnSearchFeilds";
import {
  BUTTON_LABELS,
  GRN_BREADCRUMBS,
  GRN_SECTIONS,
  PAGE_TITLES,
} from "../../utils/sys/GrnLabels";
import { GRN_SUCCESS_MESSAGES, GRN_ERROR_MESSAGES } from "../../utils/sys/GrnValidation";
import { GRN_ROUTES } from "../../utils/sys/GrnRoutes";
import {
  createInitialFilters,
  useGrnStatusTypes,
  useWarehouseOptions,
} from "./hooks/useGrnFilters";
import { useAlertQueue } from "../../hooks/useAlertQueue";
import {
  GRN_APPROVER_FILTER,
  GRN_APPROVER_FILTER_MYACTION,
  GRN_APPROVER_STATUS,
  GRN_RETURN_APPROVAL_FILTER,
  GRN_RETURN_PROCESS_STATUS,
} from "../../utils/sys/GrnConstants";
import FilterMyActionSearch from "../../components/grn/FilterMyActionSearch";
import { CON_STATUS_RETURNSAVED, CON_STATUS_RETURNSUBMITTED, CON_TRSTS_RETURN } from "../../utils/sys/Constants";
import ApprovalActionDialogreturn from "../../components/grn/grnpopup/ApprovalActionDialogreturn";
import ViewDataGridGrnApprover from "../../components/grid/ViewDataGridGrnApprover";
const MyActionApprover: React.FC = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const { setPageData } = useContext(PageDataContext);

  useEffect(() => {
    setPageData({
    title: PAGE_TITLES.MY_ACTIONS,
      // icon: <HomeIcon />,
      // showBackButton: false,
      // customActions: <button>Refresh</button>,
      // breadcrumbs: ["Home", "Dashboard"],
    });
  }, [setPageData]);
  const [selectedIds, setSelectedIds] = useState<AnyForNow[]>([]);
  const [openRejectDialog, setOpenRejectDialog] = useState<boolean>(false);
  const [openApproveDialog, setOpenApproveDialog] = useState<boolean>(false);
  const [openReturnDialog, setOpenReturnDialog] = useState<boolean>(false);
  const { alertState, showAlert, handleClose: handleAlertClose } = useAlertQueue();
  const { open: alertOpen, type: alertType, message: alertMessage } = alertState;
  const SYS_USER = useSelector((state: AnyForNow) => state.user) || {};
  const { STAFFMAPLOCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
  const [allfullData, setAllfullData] = useState<AnyForNow[]>([]);
   const [filteredfullRows, setFilteredfullRows] = useState<AnyForNow[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  // Inside ViewApproverGrn
  const [checked, setChecked] = React.useState<boolean>(false);
  const [selectedGrnCode, setSelectedGrnCode] = useState<string[]>([]);
    const [selectedRtnCode, setSelectedRtnCode] = useState<AnyForNow[]>([]);
  const showSuccess = (msg: string): void => {
    showAlert(msg, "success");
  };
  const [actionTypeOptions, setActionTypeOptions] = useState<AnyForNow[]>([
    { value: "GRN", label: "GRN" },
    { value: "Return", label: "Return" },
  ]);
  // Button click handler
  const handleApproveClick = (): void => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenApproveDialog(true);
  };
  const handleRejectClick = (): void => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenRejectDialog(true);
  };

  const handleReturnClick = (): void => {
    if (selectedIds.length === 0) {
      showError(GRN_ERROR_MESSAGES.SELECT_AT_LEAST_ONE_GRN);
      return;
    }
    // setSelectedGrnCode(selectedIds[0]);
    setOpenReturnDialog(true);
  };

  // const handleRowSelection = (ids) => {
  //   setSelectedIds(ids);

  //   if (ids.length === 1) {
  //     const selectedRow = filteredRows.find((row) => row.id === ids[0]);
  //     if (selectedRow) {
  //       setSelectedGrnCode(selectedRow.grncode);
  //     }
  //   } else {
  //     setSelectedGrnCode("");
  //   }
  // };

const handleRowSelection = (ids: AnyForNow[]): void => {
  if (!ids.length) {
    setSelectedIds([]);
    setSelectedGrnCode([]);
      setSelectedRtnCode([]);
    return;
  }

  // Find all selected rows
  const selectedRows = filteredRows.filter((row) => ids.includes(row.id));

  // Get the trsts of the first selected row
  const firstStatus = selectedRows[0]?.trsts;

  // Check if all selected rows share the same trsts
  const allSameStatus = selectedRows.every((row) => row.trsts === firstStatus);

  if (!allSameStatus) {
    // Block selection of rows with mixed status
    console.warn("Selection blocked: Different status (trsts) detected.");
    showError(GRN_ERROR_MESSAGES.SELECT_SAME_STATUS);

    // Revert to previously valid selection
    return;
  }

  // Allowed â€” update selected rows and GRN codes
  setSelectedIds(ids);
  setSelectedGrnCode(selectedRows.map((row) => row.grncode));
    setSelectedRtnCode(selectedRows.map((row) => row.grnreturncode));
};



  const [filteredRows, setFilteredRows] = useState<AnyForNow[]>([]);
  const warehouseOptions = useWarehouseOptions(COMPCODE);
const excludedStatuses = GRN_APPROVER_FILTER_MYACTION.EXCLUDED_STATUS as readonly string[];
const excludedStatusesApi = GRN_APPROVER_FILTER_MYACTION.EXCLUDED_STATUS_API as readonly string[];

const statusFilter = useCallback(
  (item: AnyForNow) =>
   
    excludedStatuses.includes(String(item.trsts)),
  []
);
  const initialVisibleStatuses =
   GRN_APPROVER_FILTER_MYACTION.INITIAL_VISIBLE_STATUSES as readonly string[];

  const { statusTypes: grnStatusTypes } = useGrnStatusTypes({
    filter: statusFilter,
    mapStatus: (item) => ({
      ...item,
      grnstatus: item.trappuserremark,
      grnstatuscode: item.trsts,
      colorcode: item.colorcode || GRN_APPROVER_FILTER.STATUS_COLOR_FALLBACK,
    }),
    deps: [statusFilter],
  });
  const [filters, setFilters] = useState<GrnFilterState>(createInitialFilters());
  const showError = (msg: string): void => {
    showAlert(msg, "error");
  };

const handleItemClick = (
  grncode: string,
  trsts: string,
  actionText: string,
  grnreturncode?: string,
  returneddate?: string
): void => {
  if (
    actionText === BUTTON_LABELS.VIEW &&
    trsts === CON_STATUS_RETURNSUBMITTED
  ) {
    navigate(GRN_ROUTES.VIEW_RETURN_GRN_DETAIL, {
      state: {
        grncode,
        trsts,
        origin: GRN_RETURN_APPROVAL_FILTER.ORIGIN,
        origin_1: GRN_RETURN_APPROVAL_FILTER.ACTION_APPROVER_RETURN,
        grnreturncode,
        returneddate,
      },
    });
  } else if (actionText === BUTTON_LABELS.VIEW) {
    navigate(GRN_ROUTES.VIEW_DETAIL, {
      state: {
        grncode,
        trsts,
        origin: GRN_APPROVER_FILTER.ORIGIN,
          origin_1: GRN_RETURN_APPROVAL_FILTER.ACTION_APPROVER_RETURN,
      },
    });
  }
};

  // Refs to prevent duplicate API calls
  const hasFetchedGrnListRef = React.useRef(false);
  const grnStatusTypesRef = React.useRef<AnyForNow[]>([]);
  const isInitialLoadRef = React.useRef(true);

  // Update ref when grnStatusTypes changes
  React.useEffect(() => {
    grnStatusTypesRef.current = grnStatusTypes;
  }, [grnStatusTypes]);

  // Consolidated: Single API call that processes data for both filtered and full lists
  const fetchGrnListData = useCallback(async (forceRefresh = false): Promise<void> => {
    if (!COMPCODE || !STAFFMAPLOCODE) {
      return;
    }

    // Prevent duplicate calls unless forced refresh
    if (hasFetchedGrnListRef.current && !forceRefresh) {
      return;
    }

    try {
      hasFetchedGrnListRef.current = true;
      setLoading(true);

      // Single API call instead of two duplicate calls
      const result = await externalgetApi(GRN_API_02_2, "GET", {
        COMPCODE,
        LOCCODE: STAFFMAPLOCODE,
      });

      if (!Array.isArray(result)) {
        setAllfullData([]);
        setFilteredRows([]);
        setLoading(false);
        return;
      }

      // Filter out items with trsts = "2"
      const filteredResult_1 = result.filter(
        (item) => excludedStatusesApi.includes(String(item.trsts))
      );

console.log("F1", filteredResult_1);

const result_2 = await externalgetApi(GRN_API_17, "GET", {
  COMPCODE,
  LOCCODE: STAFFMAPLOCODE,
  TRCATCODE: CON_TRSTS_RETURN,
});

const filteredResult = Array.isArray(result_2)
  ? result_2.filter((item) => String(item.trsts) === CON_STATUS_RETURNSUBMITTED)
  : [];

console.log("F2", filteredResult); 

const availableActionTypes = [
  ...(filteredResult_1.length > 0 ? [{ value: "GRN", label: "GRN" }] : []),
  ...(filteredResult.length > 0 ? [{ value: "Return", label: "Return" }] : []),
];

setActionTypeOptions(availableActionTypes.length > 0 ? availableActionTypes : [
  { value: "GRN", label: "GRN" },
  { value: "Return", label: "Return" },
]);

// Tag origin explicitly instead of relying on item.trcatcode from the API
const grnRows = filteredResult_1.map((item) => ({
  ...item,
  __actionType: "GRN",
}));

const returnRows = filteredResult.map((item) => ({
  ...item,
  __actionType: "Return",
}));

const combinedResult = [...grnRows, ...returnRows];

console.log("Combined Result", combinedResult);


    if (combinedResult.length === 0) {
      setFilteredRows([]);
      setLoading(false);
      return;
    }




      // Process data once and create both filtered versions
      const rowsWithId = combinedResult.map((item, index) => {
        const matchedStatus = grnStatusTypesRef.current.find(
          (status) => String(status.trsts) === String(item.trsts)
        );

        return {
          ...item,
        id: item.__actionType === "Return"
      ? `RET-${item.grnreturncode || index}`
      : `GRN-${item.grncode || index}`,
          invoicedate: FormatDate(item.invoicedate) || null,
          endate: FormatDate(item.endate) || null,
          statusLabel: matchedStatus?.trappuserremark || GRN_BREADCRUMBS.STATUS_FALLBACK,
          statusColor:
            matchedStatus?.colorcode || GRN_APPROVER_FILTER.STATUS_COLOR_FALLBACK,
          invoicedateRaw: item.invoicedate, // for filtering
          endateRaw: item.endate,
          pocode: item.pocode,
           grnstatuscode: item.trsts,
        Supplier: `${item.suprefcode} - ${item.suppliername}`,
                                   // keep original for filtering
  trcatcode: item.__actionType,      
  grncode: item.grncode || "-", // keep original for filtering
  grnreturncode: item.grnreturncode || "-", // keep original for filtering
        };
      });

      // Set full data (all statuses except "2")
      setAllfullData(rowsWithId);

    

      setFilteredRows(rowsWithId);
    } catch (err) {
      console.error("Error fetching GRN list data:", err);
      hasFetchedGrnListRef.current = false; // Reset on error to allow retry
    } finally {
      setLoading(false);
    }
  }, [COMPCODE, STAFFMAPLOCODE]);

  // Initial load - only fetch when status types are loaded
  useEffect(() => {
    if (grnStatusTypes.length > 0 && isInitialLoadRef.current && COMPCODE && STAFFMAPLOCODE) {
      isInitialLoadRef.current = false;
      fetchGrnListData();
    }
  }, [fetchGrnListData, grnStatusTypes.length, COMPCODE, STAFFMAPLOCODE]);




const isReturnSelected = React.useMemo(
  () =>
    filteredRows
      .filter((row) => selectedIds.includes(row.id))
      .some((row) => String(row.trsts) === CON_STATUS_RETURNSUBMITTED),
  [filteredRows, selectedIds]
);

useEffect(() => {
  if (!allfullData.length) {
    setFilteredRows([]);
    return;
  }

  let filtered = allfullData;

   const searchValue = String(filters.searchValue || filters.grnId || "").trim().toLowerCase();
  if (searchValue) {
    filtered = filtered.filter((item) => {
      const grnCode = String(item.grncode || "").toLowerCase();
      const returnCode = String(item.grnreturncode || "").toLowerCase();
       const supplierName = String(item.suppliername || "").toLowerCase();
       const supplierCode = String(item.suprefcode || "").toLowerCase();
      return grnCode.includes(searchValue) || returnCode.includes(searchValue) || supplierName.includes(searchValue) || supplierCode.includes(searchValue);
    });
  }

if (filters.grnId) {
  const search = filters.grnId.toLowerCase();

  filtered = filtered.filter((item) => {
    const grnCode = String(item.grncode || "").toLowerCase();
    const returnCode = String(item.grnreturncode || "").toLowerCase();

    return (
      grnCode.includes(search) ||
      returnCode.includes(search)
    );
  });
}

if (filters.warehouse) {
  filtered = filtered.filter(
    (item) => String(item.restcode) === String(filters.warehouse)
  );
}
 if (filters.actionType) {
    filtered = filtered.filter(
      (item) => String(item.trcatcode) === String(filters.actionType)
    );
  }

  if (filters.status) {
    filtered = filtered.filter(
      (item) => String(item.grnstatuscode) === String(filters.status)
    );
  }

 if (filters.fromDate && filters.toDate) {
  const from = new Date(filters.fromDate);
  const to = new Date(filters.toDate);

  const start = from < to ? from : to;
  const end = from < to ? to : from;

  filtered = filtered.filter(
    (item) => {
      const date = new Date(item.invoicedateRaw || item.endateRaw);
      return date >= start && date <= end;
    }
  );
} else if (filters.fromDate) {
  const from = new Date(filters.fromDate);
  filtered = filtered.filter(
    (item) => new Date(item.invoicedateRaw) >= from
  );
} else if (filters.toDate) {
  const to = new Date(filters.toDate);
  filtered = filtered.filter(
    (item) => new Date(item.endateRaw) <= to
  );
}


  setFilteredRows(filtered);
}, [filters, allfullData]);

  // Keep selected IDs in sync with the currently visible rows
  useEffect(() => {
    if (!selectedIds || selectedIds.length === 0) return;
    const validIds = selectedIds.filter((id) =>
      filteredRows.some((r) => r.id === id),
    );

    if (validIds.length !== selectedIds.length) {
      setSelectedIds(validIds);
      // update corresponding grn codes
      const validGrnCodes = validIds
        .map((id) => filteredRows.find((r) => r.id === id))
        .filter(Boolean)
        .map((r: AnyForNow) => r.grncode || "");
      setSelectedGrnCode(validGrnCodes);
    }

    // If filteredRows became empty, clear selection
    if (filteredRows.length === 0 && selectedIds.length > 0) {
      setSelectedIds([]);
      setSelectedGrnCode([]);
    }
  }, [filteredRows, selectedIds]);

  const handleFilterChange = (newFilters: GrnFilterState): void => {
    setFilters(newFilters);
  };
  const menuItems = [
    {
      text: BUTTON_LABELS.VIEW,
      icon: <VisibilityOutlinedIcon />,
      onClick: (row: AnyForNow) => handleItemClick(row.grncode,row.trsts, BUTTON_LABELS.VIEW,row.grnreturncode, row.returneddate),
    },
  ];

  return (
    <>
      <Box sx={styles.box_breadcrumb_view}>
        <Breadcrumbs
          separator={GRN_BREADCRUMBS.SEPARATOR}
          aria-label="breadcrumb"
          sx={styles.breadcrumb}
        >
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.HOME}
          </Link>
          <Link
            underline="hover"
            sx={styles.breadcrumb_link}
            // href=""
          >
            {GRN_BREADCRUMBS.MY_ACTIONS}
          </Link>
          <Link
            sx={styles.breadcrumb_link_page}
            underline="hover"
            // href="#"
            aria-current="page"
          >
            {GRN_BREADCRUMBS.MYACTION_APPROVER}{" "}
          </Link>
        </Breadcrumbs>
      </Box>

      <Box sx={styles.box_page_container}>
        <AppBar sx={styles.vg_appbar}>
          <Grid container spacing={2} sx={styles.appbar_grid_container}>
            <Grid
              size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}
              sx={styles.appbar_grid_container_col_1}
            >
              <Typography sx={styles.appbar_title}>
                {ViewMyApproverInitiator.name}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8, xl: 8 }}>
  {(() => {
  const selectedRows = filteredRows.filter((row) =>
    selectedIds.includes(row.id)
  );

  // Decide which button-set to show based on the selected row's trsts
  const isReturnSelected = selectedRows.some(
    (row) => String(row.trsts) === CON_STATUS_RETURNSUBMITTED
  );

  if (isReturnSelected) {
    // ---- RETURN flow buttons ----
    const hasStatus1 = selectedRows.some(
      (row) => String(row.trsts) === GRN_RETURN_PROCESS_STATUS.DIRECT_RETURN
    );
    const hasStatus2 = selectedRows.some(
      (row) => String(row.trsts) === GRN_RETURN_PROCESS_STATUS.DRAFT
    );
    const hasStatus3 = selectedRows.some(
      (row) => String(row.trsts) === GRN_RETURN_PROCESS_STATUS.APPROVAL_REQUIRED
    );

    return (
      <Box
        sx={{
          gap: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleRejectClick}
          disabled={!hasStatus3 && !hasStatus2}
        >
          Reject
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          sx={{ ...styles.btn_primary }}
          onClick={handleApproveClick}
          disabled={!hasStatus3 && !hasStatus2}
        >
          Approve
        </Button>
      </Box>
    );
  }

  // ---- GRN (approver) flow buttons ----
  const hasStatus1 = selectedRows.some(
    (row) => String(row.trsts) === GRN_APPROVER_STATUS.RETURN_ALLOWED
  );
  const hasStatus3 = selectedRows.some(
    (row) => String(row.trsts) === GRN_APPROVER_STATUS.APPROVE_REJECT_ALLOWED
  );

  return (
    <Box
      sx={{
        gap: 1,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ ...styles.btn_primary }}
        onClick={handleReturnClick}
        disabled={!hasStatus1}
      >
        {BUTTON_LABELS.RETURN}
      </Button>

      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ ...styles.btn_primary }}
        onClick={handleRejectClick}
        disabled={!hasStatus1 && !hasStatus3}
      >
        {BUTTON_LABELS.REJECT}
      </Button>

      <Button
        variant="contained"
        color="primary"
        size="small"
        sx={{ ...styles.btn_primary }}
        onClick={handleApproveClick}
        disabled={!hasStatus1 && !hasStatus3}
      >
        {BUTTON_LABELS.APPROVE}
      </Button>
    </Box>
  );
})()}


            </Grid>
            {/* <Grid
              size={{ xs: 12, sm: 12, md: 1, lg: 1, xl: 1 }}
              sx={styles.vg_grid_new_button}
            >
              <Button
                variant="contained"
                startIcon={<AddCircleOutlineIcon />}
                size="small"
                sx={{ ...styles.btn_primary, ...styles.btn_appbar_add }}
                onClick={goToCreateGrn}
              >
                New
              </Button>
            </Grid> */}
          </Grid>
        </AppBar>
       {/* <FilterGrnSearch /> */}
           <FilterMyActionSearch
          warehouseOptions={warehouseOptions}
          grnStatusTypes={grnStatusTypes}
          onFilterChange={handleFilterChange}
          actionTypeOptions={actionTypeOptions}
           searchFields={SEARCH_FIELDS_MYACTIONS}
        />

        <Box sx={styles.view_page_container}>
          < ViewDataGridGrnApprover
            columns={ViewMyApproverInitiator.columns}
         rows={filteredRows}
            menuItems={menuItems}
            // statusOptions={statusOptions}
            tabletitle={ViewMyApproverInitiator.name}
            gridid={GRN_APPROVER_FILTER.GRID_ID}
            {...({sx: styles.view_data_grid_page} as any)}
            onSelectionChange={handleRowSelection}
            grnStatusTypes={grnStatusTypes}
            selectionModel={selectedIds}
            disableMultipleSelection
            loading={loading}
          />
        </Box>
      </Box>
  {isReturnSelected ? (
  <>
  <ApprovalActionDialogreturn
      open={openApproveDialog}
      handleClose={() => setOpenApproveDialog(false)}
      actionType={BUTTON_LABELS.APPROVE}
      grnCodes={selectedGrnCode}
      rtncodes={selectedRtnCode}
      enUser={USERNAME}
      onSuccess={() => {
        fetchGrnListData(true); // Refresh data after status change (force refresh)
        setOpenApproveDialog(false);
        setSelectedIds([]);
        setSelectedGrnCode([]);
        setSelectedRtnCode([]);
        showSuccess(GRN_SUCCESS_MESSAGES.APPROVE_SUCCESS);
      }}
    />
    <ApprovalActionDialogreturn
      open={openReturnDialog}
      handleClose={() => setOpenReturnDialog(false)}
      actionType={BUTTON_LABELS.RETURN}
      grnCodes={selectedGrnCode}
      rtncodes={selectedRtnCode}
      enUser={USERNAME}
      onSuccess={() => {
        fetchGrnListData(true); // Refresh data after status change (force refresh)
        setOpenReturnDialog(false);
        setSelectedIds([]);
        setSelectedGrnCode([]);
        setSelectedRtnCode([]);
        showSuccess(GRN_SUCCESS_MESSAGES.RETURN_SUCCESS);
      }}
    />
    <ApprovalActionDialogreturn
      open={openRejectDialog}
      handleClose={() => setOpenRejectDialog(false)}
      actionType={BUTTON_LABELS.REJECT}
      grnCodes={selectedGrnCode}
      rtncodes={selectedRtnCode}
      enUser={USERNAME}
      onSuccess={() => {
        fetchGrnListData(true); // Refresh data after status change (force refresh)
        setOpenRejectDialog(false);
        setSelectedIds([]);
        setSelectedGrnCode([]);
        setSelectedRtnCode([]);
        showSuccess(GRN_SUCCESS_MESSAGES.REJECT_SUCCESS);
      }}
    />
   
  </>
) : (
  <>
    <ApprovalActionDialog
      open={openApproveDialog}
      handleClose={() => setOpenApproveDialog(false)}
      actionType={BUTTON_LABELS.APPROVE}
      grnCodes={selectedGrnCode}
      enUser={USERNAME}
      onSuccess={() => {
        fetchGrnListData(true); // Refresh data after status change (force refresh)
        setOpenApproveDialog(false);
        setSelectedIds([]);
        setSelectedGrnCode([]);
        showSuccess(GRN_SUCCESS_MESSAGES.APPROVE_SUCCESS);
      }}
    />
    <ApprovalActionDialog
      open={openReturnDialog}
      handleClose={() => setOpenReturnDialog(false)}
      actionType={BUTTON_LABELS.RETURN}
      grnCodes={selectedGrnCode}
      enUser={USERNAME}
      onSuccess={() => {
        fetchGrnListData(true); // Refresh data after status change (force refresh)
        setOpenReturnDialog(false);
        setSelectedIds([]);
        setSelectedGrnCode([]);
        showSuccess(GRN_SUCCESS_MESSAGES.RETURN_SUCCESS);
      }}
    />
    <ApprovalActionDialog
      open={openRejectDialog}
      handleClose={() => setOpenRejectDialog(false)}
      actionType={BUTTON_LABELS.REJECT}
      grnCodes={selectedGrnCode}
      enUser={USERNAME}
      onSuccess={() => {
        fetchGrnListData(true); // Refresh data after status change (force refresh)
        setOpenRejectDialog(false);
        setSelectedIds([]);
        setSelectedGrnCode([]);
        showSuccess(GRN_SUCCESS_MESSAGES.REJECT_SUCCESS);
      }}
    />
  </>
)}
      <SystemAlert
        open={alertOpen}
        type={alertType}
        message={alertMessage}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default MyActionApprover;
